import {
    getNotifications
} from '@/services/endpoints/legalReferenceNotifications'

export default {
    async getNotifications({ commit }, userId) {
        try {
            let res = await getNotifications(userId)
            if(res) {
                commit('SET_NOTIFICATION',res.data);
            }
            else{
                throw {}
            }
        }
        catch (err) {
            throw err
        }
    },
}
